import {node} from 'ln/node/Node';
import View from 'ln/view/View';
import {Text} from './Text';
import {renderer} from 'ln/view/Renderer';


export class TextView extends View<Text> {

    public constructor() {
        super({ template: '<div class="text-style spacer-box -pv-2x -mh-6x"></div>' })
    }

    protected init(): void {
        let { level, text } = this.data;
        this.node.classList.add(level ? '-h' + level : '-p');
        text = renderer.context.downloadPath( text );
        this.node.appendChild(node(text).native);
    }
}
